var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoBackground = function SvgLogoBackground(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 541.846,
    height: 546.444,
    viewBox: "230 0 541.846 546.444",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(8,133,213,0.19)",
    stroke: "rgba(0,0,0,0)",
    d: "M270.425,545.444a270.209,270.209,0,0,1-54.5-5.541,267.744,267.744,0,0,1-96.7-41.035A272.846,272.846,0,0,1,5.494,327.686a277.676,277.676,0,0,1,0-109.927A273.049,273.049,0,0,1,119.228,46.577a268.33,268.33,0,0,1,302.392,0A272.848,272.848,0,0,1,535.351,217.759a277.687,277.687,0,0,1,0,109.927A273.042,273.042,0,0,1,421.62,498.868a267.652,267.652,0,0,1-151.2,46.576Zm38.6-420.207A191.638,191.638,0,0,0,156.1,200.426c-64.877,84.246-49.12,205.566,35.125,270.445a192.816,192.816,0,0,0,270.444-35.125C526.551,351.5,510.794,230.179,426.548,165.3A191.023,191.023,0,0,0,309.026,125.237Z",
    transform: "translate(0.5 0.5)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoBackground, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoBackground.d3c6e9d8.svg";
export { ForwardRef as ReactComponent };